var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg05Blue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58.131,
    height: 58.131,
    rx: 29.0655,
    fill: "#2A71FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4268 38.4784C19.156 38.4784 17.427 37.6526 16.24 36.0011C15.053 34.3496 14.4595 31.9755 14.4595 28.8789C14.4595 25.7823 15.053 23.4083 16.24 21.7568C17.427 20.1052 19.156 19.2795 21.4268 19.2795C23.6977 19.2795 25.4266 20.1052 26.6136 21.7568C27.8007 23.4083 28.3942 25.7823 28.3942 28.8789C28.3942 32.0013 27.8007 34.3754 26.6136 36.0269C25.4266 37.6784 23.6977 38.4784 21.4268 38.4784ZM21.4268 36.0785C24.1622 36.0785 25.5298 33.6787 25.5298 28.8789C25.5298 24.0792 24.1622 21.6793 21.4268 21.6793C18.6915 21.6793 17.3496 24.0792 17.3496 28.8789C17.3496 33.6787 18.6915 36.0785 21.4268 36.0785ZM37.639 26.0404C39.6002 26.0404 41.1227 26.6339 42.2581 27.7951C43.3419 28.9563 43.9096 30.4272 43.9096 32.2078C43.9096 34.0657 43.2903 35.5882 42.1033 36.7236C40.8646 37.9107 39.2647 38.4784 37.3035 38.4784C35.4972 38.4784 33.9747 37.9881 32.7877 36.9559C31.6006 35.9753 30.9555 34.6076 30.8265 32.9045H33.5102C33.6134 33.8851 34.0263 34.6851 34.723 35.2528C35.4198 35.8463 36.2713 36.1301 37.3035 36.1301C38.439 36.1301 39.3421 35.7689 40.0647 35.0463C40.7872 34.3238 41.1485 33.369 41.1485 32.2078C41.1485 31.0466 40.7872 30.0918 40.0647 29.3692C39.3421 28.6467 38.439 28.2596 37.3035 28.2596C35.652 28.2596 34.465 28.9563 33.7683 30.324H31.2394L32.8651 19.6924H42.8516V22.0922H35.0327L34.2069 27.3564C35.1875 26.4791 36.3229 26.0404 37.639 26.0404Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg05Blue);
export default __webpack_public_path__ + "static/media/05-blue.b6e293c57e22bf9c375c3519aa99051a.svg";
export { ForwardRef as ReactComponent };